import { SHOW_LOADING, HIDE_LOADING } from './loadingActions';

export const initialState = false;

export const reducer = (state, action) => {
  switch (action.type) {
    case SHOW_LOADING: {
      return true;
    }
    case HIDE_LOADING: {
      return false;
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};
